import type { CareServicePopulatedResponseDto, OrderPopulatedResponseDto } from '@pflegix/types';

/**
 * Checks if the given order has a care service.
 * @param order - The order to check.
 * @returns A boolean indicating whether the order has a care service.
 */
export function hasCareService(
  order: OrderPopulatedResponseDto
): order is OrderPopulatedResponseDto & { services: { care: CareServicePopulatedResponseDto } } {
  return !!order.services.care;
}
